const SVG_PROPS = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
};

/** Platform icons for the job share menu — matches company-link stroke style. */
export default function SharePlatformIcon({ platform, className = "" }) {
  const iconClass = `nd1-job-share-menu__item-icon nd1-job-share-menu__item-icon--${platform}${
    className ? ` ${className}` : ""
  }`;

  if (platform === "copy") {
    return (
      <svg className={iconClass} {...SVG_PROPS}>
        <path d="m15.988 13 3.902-3.902c1.437-1.437 1.485-3.718.107-5.095-1.377-1.378-3.658-1.33-5.095.107L11 8.012m2 7.95-3.892 3.88c-1.432 1.43-3.64 1.615-5.082.107-1.442-1.507-1.326-3.639.107-5.068L8.025 11M9 15l6-6" />
      </svg>
    );
  }

  if (platform === "linkedin") {
    return (
      <svg className={iconClass} {...SVG_PROPS}>
        <path d="M3 9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h5.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v5.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36-.436-4.216-1.748A4 4 0 0 1 3 14.6zm5-1.775v.5" />
        <path d="M8 16.375V10.75m4 5.625V13.5m0 0v-2.75m0 2.75c0-1.288 1.222-2 2.4-2 1.6 0 1.6 1.375 1.6 2.875v2" />
      </svg>
    );
  }

  if (platform === "facebook") {
    return (
      <svg className={iconClass} {...SVG_PROPS}>
        <path d="M6.5 10v4h3v7h4v-7h3l1-4h-4V8c0-.545.455-1 1-1h3V3h-3c-2.723 0-5 2.277-5 5v2z" />
      </svg>
    );
  }

  if (platform === "x") {
    return (
      <svg className={iconClass} {...SVG_PROPS}>
        <path d="M4 4l16 16M20 4 4 20" />
      </svg>
    );
  }

  if (platform === "whatsapp") {
    return (
      <svg className={iconClass} {...SVG_PROPS}>
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        <path d="M9.5 10.5c.35.95 1.05 1.85 1.85 2.55.8.7 1.75 1.25 2.75 1.55" />
      </svg>
    );
  }

  if (platform === "email") {
    return (
      <svg className={iconClass} {...SVG_PROPS}>
        <path d="m2.357 7.714 6.98 4.654c.963.641 1.444.962 1.964 1.087.46.11.939.11 1.398 0 .52-.125 1.001-.446 1.964-1.087l6.98-4.654M7.157 19.5h9.686c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.31-1.311c.328-.642.328-1.482.328-3.162V9.3c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311c-.642-.327-1.482-.327-3.162-.327H7.157c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.31 1.311c-.328.642-.328 1.482-.328 3.162v5.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311c.642.327 1.482.327 3.162.327" />
      </svg>
    );
  }

  return null;
}
